"use client";

import { Radio } from "lucide-react";
import { SpecialRow } from "@/data/specials";
import dayjs from "@punchup/utils/dayjs";
import { useLivestream } from "@/hooks/useLivestream";
import { type Dayjs } from "dayjs";

interface Props {
  special: SpecialRow;
  displayFeatured?: boolean;
  className?: string;
}

/**
 * Badge overlay representing a special that is of type "livestream"
 *
 * @param special - The special/video data including pricing, runtime, and unlock status
 * @param displayFeatured - display the "Featured" badge?
 * @param comedianDisplayName - The comedian's display name for alt text
 */
export default function ComedianVideoLivestreamBadge({ special }: Props) {
  const { livestream } = useLivestream({ livestreamId: special.livestream });

  const formatDatetime = (datetime: Dayjs) => {
    const minuteValue = datetime.minute();
    if (minuteValue === 0) {
      return datetime.format("MMM D – hA");
    }
    return datetime.format("MMM D – h:mmA");
  };

  if (!livestream) return null;

  const datetime = dayjs(livestream.start_time);

  return (
    <div className="bg-[#EE3233] text-white text-xs font-semibold flex flex-row gap-1 rounded-[4px] py-1 px-[5px] items-center">
      <Radio height={12} width={12} />
      <span>Live stream: {formatDatetime(datetime)}</span>
    </div>
  );
}
